import { cbi_energy_source_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiEnergySourceTypeEnum = (enumValue: cbi_energy_source_type_enum) => {
  switch (enumValue) {
    case cbi_energy_source_type_enum.BIO_GAS:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-BIO_GAS" />;
    case cbi_energy_source_type_enum.COAL:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-COAL" />;
    case cbi_energy_source_type_enum.DISTRICT_HEATING:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-DISTRICT_HEATING" />;
    case cbi_energy_source_type_enum.ELECTRICITY_GREEN:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-ELECTRICITY_GREEN" />;
    case cbi_energy_source_type_enum.ELECTRICITY_MIX:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-ELECTRICITY_MIX" />;
    case cbi_energy_source_type_enum.FUEL_OIL:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-FUEL_OIL" />;
    case cbi_energy_source_type_enum.LIGNITE:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-LIGNITE" />;
    case cbi_energy_source_type_enum.LPG:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-LPG" />;
    case cbi_energy_source_type_enum.NATURAL_GAS:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-NATURAL_GAS" />;
    case cbi_energy_source_type_enum.SOLAR:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-SOLAR" />;
    case cbi_energy_source_type_enum.WOOD:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-WOOD" />;
    case cbi_energy_source_type_enum.WOODEN_PELLETS:
      return <Trans i18nKey="Enum_CbiEnergySourceTypeEnum-WOODEN_PELLETS" />;
  }
};

export const translateCbiEnergySourceTypeEnum_dynamic = (enumValue: cbi_energy_source_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_energy_source_type_enum.BIO_GAS:
      return t('Enum_CbiEnergySourceTypeEnum-BIO_GAS');
    case cbi_energy_source_type_enum.COAL:
      return t('Enum_CbiEnergySourceTypeEnum-COAL');
    case cbi_energy_source_type_enum.DISTRICT_HEATING:
      return t('Enum_CbiEnergySourceTypeEnum-DISTRICT_HEATING');
    case cbi_energy_source_type_enum.ELECTRICITY_GREEN:
      return t('Enum_CbiEnergySourceTypeEnum-ELECTRICITY_GREEN');
    case cbi_energy_source_type_enum.ELECTRICITY_MIX:
      return t('Enum_CbiEnergySourceTypeEnum-ELECTRICITY_MIX');
    case cbi_energy_source_type_enum.FUEL_OIL:
      return t('Enum_CbiEnergySourceTypeEnum-FUEL_OIL');
    case cbi_energy_source_type_enum.LIGNITE:
      return t('Enum_CbiEnergySourceTypeEnum-LIGNITE');
    case cbi_energy_source_type_enum.LPG:
      return t('Enum_CbiEnergySourceTypeEnum-LPG');
    case cbi_energy_source_type_enum.NATURAL_GAS:
      return t('Enum_CbiEnergySourceTypeEnum-NATURAL_GAS');
    case cbi_energy_source_type_enum.SOLAR:
      return t('Enum_CbiEnergySourceTypeEnum-SOLAR');
    case cbi_energy_source_type_enum.WOOD:
      return t('Enum_CbiEnergySourceTypeEnum-WOOD');
    case cbi_energy_source_type_enum.WOODEN_PELLETS:
      return t('Enum_CbiEnergySourceTypeEnum-WOODEN_PELLETS');
  }
};
